import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class BarTender_ds_get_configurationsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { name?: string, $top?: number, $skip?: number }): Promise<{ result?: { Id?: string, Name?: string, Value?: string, String1?: string, String2?: string, String3?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/BarTender/datasources/ds_get_configurations/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { name?: string, $keys: string[] }): Promise<{ result?: { Id?: string, Name?: string, Value?: string, String1?: string, String2?: string, String3?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarTender/datasources/ds_get_configurations/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      name?: string    }) {
      return false;
    }
}
